import React, { FunctionComponent, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Col, Container, Row } from 'react-grid-system'
import { useLocation } from 'react-router-dom'

import { ClinAnnounceBar } from '../../components/ClinAnnounceBar'
import { AnnounceMode } from '../../components/ClinAnnounceBar/ClinAnnounceBar'
import {
  ClinPageToast,
  PAGE_TOAST_ANCHOR_ID,
  StyledPageToastAnchor
} from '../../components/ClinPageToast'
import { ClinSpacer } from '../../components/ClinSpacer'
import { useAppContext } from '../../context/app'
import {
  clearAnnounceEvent,
  updateAnnounceClearFlag
} from '../../events/AnnounceEvent'
import { AnnouncePresentation } from '../../types/IAnnouncement'

export const AnnounceContainer: FunctionComponent = () => {
  const { dispatch, announcement } = useAppContext()
  const location = useLocation()

  // Clean up announce once nav changes
  useEffect(() => {
    if (announcement?.clearOnNavigationFlag) {
      dispatch(clearAnnounceEvent())
    }
    dispatch(updateAnnounceClearFlag(true))
  }, [location.pathname, dispatch])

  if (!announcement) {
    return null
  }

  if (announcement.presentation === AnnouncePresentation.Toast) {
    const pageAnchor = document.getElementById(PAGE_TOAST_ANCHOR_ID)
    const toast = (
      <ClinPageToast
        mode={announcement.mode}
        title={announcement.title}
        message={announcement.description}
        action={announcement.action}
        onClose={() => dispatch(clearAnnounceEvent())}
        fullWidth={!!pageAnchor || announcement.mode === AnnounceMode.Error}
      />
    )
    // Pages with their own header (checkout) provide an anchor under it;
    // everywhere else the toast sits just under the main navigation.
    return pageAnchor ? (
      createPortal(toast, pageAnchor)
    ) : (
      <StyledPageToastAnchor>{toast}</StyledPageToastAnchor>
    )
  }

  return (
    <Container>
      <Row>
        <Col>
          <ClinSpacer />
          <ClinAnnounceBar
            mode={announcement.mode}
            title={announcement.title}
            isDismissible={true}
            handleClose={() => dispatch(clearAnnounceEvent())}
          >
            {announcement.description}
          </ClinAnnounceBar>
        </Col>
      </Row>
    </Container>
  )
}
